import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { customClassNames } from "./customClassNames.config";

const Styled = ({ children, className }: { children: ReactNode; className: string }) => (
  <Box sx={customClassNames} as="span">
    <Box as="span" className={className}>
      {children}
    </Box>
  </Box>
);

export default Styled;
